const C = {
  bg: "#FCFAEE", bgAlt: "#F5EFE2", surface: "#FFFFFF", border: "#E2D9CB",
  text: "#2D2A24", text2: "#71644C", textOff: "#B5A998",
  pri: "#00628F", priH: "#004E72", priL: "#E3F0F5", priG: "rgba(0,98,143,0.15)",
  sec: "#883476", secL: "#E8D0DB",
  acc: "#F9A01B", accL: "#FFF3DC",
  ok: "#157346", okL: "#E2F0E8",
  warn: "#F9A01B", warnL: "#FFF3DC",
  err: "#C0453A", errL: "#FCEAE8",
};

export function WelcomeSVG({ pulse }) {
  return (
    <svg viewBox="0 0 200 160" style={{ width: "100%", maxWidth: 220, display: "block", margin: "0 auto" }}>
      <defs>
        <linearGradient id="gw" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00628F" />
          <stop offset="100%" stopColor="#2A9D8F" />
        </linearGradient>
      </defs>
      <circle cx="100" cy="70" r={pulse ? 52 : 48} fill="url(#gw)" opacity="0.1" style={{ transition: "r 0.6s ease" }} />
      <circle cx="100" cy="70" r={pulse ? 38 : 35} fill="url(#gw)" opacity="0.15" style={{ transition: "r 0.5s ease" }} />
      <path d="M100 35 L125 48 L125 75 Q125 95 100 108 Q75 95 75 75 L75 48 Z" fill="url(#gw)" opacity="0.85" />
      <path d="M91 72 L97 80 L112 62" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M65 130 L78 130 L84 127 L92 133 L100 129 L106 130 L120 130" stroke={C.pri} strokeWidth="2.5" fill="none" strokeLinecap="round">
        {pulse && (
          <animate attributeName="d" values="M65 130 L78 130 L84 118 L92 142 L100 125 L106 130 L120 130;M65 130 L78 130 L84 127 L92 133 L100 129 L106 130 L120 130;M65 130 L78 130 L84 118 L92 142 L100 125 L106 130 L120 130" dur="1s" repeatCount="indefinite" />
        )}
      </path>
      <circle cx="120" r="3" cy="130" fill={C.pri} opacity={pulse ? 1 : 0.4}>
        {pulse && <animate attributeName="opacity" values="1;0.3;1" dur="1s" repeatCount="indefinite" />}
      </circle>
      <circle cx="140" cy="45" r={pulse ? 3 : 2} fill={C.acc} style={{ transition: "r 0.4s" }}>
        <animate attributeName="opacity" values="1;0.2;1" dur="2s" repeatCount="indefinite" />
      </circle>
      <circle cx="55" cy="40" r="2" fill={C.sec}>
        <animate attributeName="opacity" values="0.3;1;0.3" dur="1.8s" repeatCount="indefinite" />
      </circle>
      <circle cx="150" cy="80" r="2" fill={C.ok}>
        <animate attributeName="opacity" values="0.5;1;0.5" dur="2.2s" repeatCount="indefinite" />
      </circle>
      <text x="100" y="155" textAnchor="middle" fontSize="11" fill={C.text2} fontWeight="600">Tu salud, tu camino</text>
    </svg>
  );
}

export function PersonSVG({ sex, filled }) {
  const hair = sex === "Femenino" ? C.sec : sex === "Masculino" ? C.pri : C.textOff;
  const shirt = sex === "Femenino" ? "#D4A0C4" : sex === "Masculino" ? "#7DBFD0" : "#C8D0C0";
  const sc = filled ? 1 : 0.95;

  return (
    <svg viewBox="0 0 160 160" style={{ width: "100%", maxWidth: 180, display: "block", margin: "0 auto" }}>
      <defs>
        <linearGradient id="gp" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={C.pri} />
          <stop offset="100%" stopColor="#2A9D8F" />
        </linearGradient>
      </defs>
      <circle cx="80" cy="75" r="50" fill={C.priL} opacity="0.5" />
      <g transform={`translate(80,80) scale(${sc}) translate(-80,-80)`} style={{ transition: "transform 0.5s ease" }}>
        <ellipse cx="80" cy="125" rx="28" ry="18" fill={shirt} style={{ transition: "fill 0.4s" }} />
        <circle cx="80" cy="72" r="22" fill="#FFDCB5" />
        {sex === "Femenino" ? (
          <path d="M58 68 Q58 46 80 46 Q102 46 102 68 Q102 55 95 50 Q80 42 65 50 Q58 55 58 68Z" fill={hair} style={{ transition: "fill 0.4s" }} />
        ) : (
          <path d="M60 66 Q60 48 80 48 Q100 48 100 66 L98 58 Q80 44 62 58Z" fill={hair} style={{ transition: "fill 0.4s" }} />
        )}
        <ellipse cx="72" cy="74" rx="2.5" ry="2.5" fill={C.text}>
          <animate attributeName="ry" values="2.5;0.3;2.5" dur="3.5s" repeatCount="indefinite" />
        </ellipse>
        <ellipse cx="88" cy="74" rx="2.5" ry="2.5" fill={C.text}>
          <animate attributeName="ry" values="2.5;0.3;2.5" dur="3.5s" repeatCount="indefinite" />
        </ellipse>
        <path
          d={filled ? "M73 82 Q80 89 87 82" : "M75 82 Q80 85 85 82"}
          stroke={C.err}
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          style={{ transition: "d 0.5s ease" }}
        />
      </g>
      {filled && (
        <>
          <circle cx="130" cy="45" r="4" fill={C.ok} opacity="0.8">
            <animate attributeName="r" values="3;5;3" dur="2s" repeatCount="indefinite" />
          </circle>
          <circle cx="30" cy="55" r="3" fill={C.acc} opacity="0.7">
            <animate attributeName="r" values="2;4;2" dur="2.5s" repeatCount="indefinite" />
          </circle>
        </>
      )}
    </svg>
  );
}

export function BodySVG({ imc, bpClass }) {
  const w = imc ? (imc < 18.5 ? 14 : imc < 25 ? 18 : imc < 30 ? 24 : 30) : 18;
  const col = imc ? (imc < 18.5 ? C.warn : imc < 25 ? C.ok : imc < 30 ? C.warn : C.err) : C.textOff;
  const heartCol = bpClass === "normal" ? C.ok : bpClass === "elevada" ? C.warn : bpClass ? C.err : C.textOff;
  const heartR = bpClass === "normal" ? 6 : bpClass === "elevada" ? 7 : bpClass === "hta1" ? 8 : bpClass === "hta2" ? 9 : 6;
  const heartDur = bpClass === "hta2" ? "0.6s" : bpClass === "hta1" ? "0.8s" : "1.2s";

  return (
    <svg viewBox="0 0 160 160" style={{ width: "100%", maxWidth: 180, display: "block", margin: "0 auto" }}>
      <circle cx="80" cy="80" r="55" fill={C.priL} opacity="0.4" />
      <ellipse cx="80" cy="105" rx={w} ry="30" fill={col} opacity="0.2" style={{ transition: "all 0.6s ease" }} />
      <ellipse cx="80" cy="105" rx={w - 3} ry="27" fill={col} opacity="0.15" style={{ transition: "all 0.6s ease" }} />
      <circle cx="80" cy="52" r="16" fill={col} opacity="0.25" style={{ transition: "fill 0.5s" }} />
      <g transform="translate(80,90)">
        <path
          d={`M0 ${heartR * 0.4} C-${heartR} -${heartR * 0.6} -${heartR * 1.8} ${heartR * 0.2} 0 ${heartR * 1.2} C${heartR * 1.8} ${heartR * 0.2} ${heartR} -${heartR * 0.6} 0 ${heartR * 0.4}Z`}
          fill={imc ? heartCol : C.textOff}
          opacity="0.7"
          style={{ transition: "all 0.5s ease" }}
        >
          <animate attributeName="opacity" values="0.7;0.4;0.7" dur={heartDur} repeatCount="indefinite" />
        </path>
      </g>
      {imc && (
        <g opacity="0.5">
          <circle cx="80" cy="90" r="18" fill="none" stroke={heartCol} strokeWidth="1" opacity="0.3">
            <animate attributeName="r" values="18;30;18" dur="2s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.3;0;0.3" dur="2s" repeatCount="indefinite" />
          </circle>
        </g>
      )}
      {imc && (
        <text x="80" y="145" textAnchor="middle" fontSize="14" fontWeight="800" fill={col}>
          IMC {imc}
        </text>
      )}
    </svg>
  );
}

export function LifestyleSVG({ tobacco, alcohol, sleep }) {
  const sleepH = sleep ? parseFloat(sleep) : 0;
  const moonY = 40;
  const stars = sleepH >= 7 ? 5 : sleepH >= 5 ? 3 : 1;

  return (
    <svg viewBox="0 0 200 140" style={{ width: "100%", maxWidth: 220, display: "block", margin: "0 auto" }}>
      <rect x="10" y="10" width="180" height="120" rx="16" fill={C.priL} opacity="0.3" />
      {/* Sleep */}
      <g transform="translate(20,20)">
        <circle cx="25" cy={moonY} r="14" fill="#FDE68A">
          <animate attributeName="opacity" values="0.8;1;0.8" dur="3s" repeatCount="indefinite" />
        </circle>
        <circle cx="18" cy={moonY - 4} r="11" fill={C.priL} />
        {Array.from({ length: stars }).map((_, i) => (
          <circle key={i} cx={10 + i * 12} cy={24 + (i % 2) * 6} r="2" fill="#FDE68A" opacity="0.7">
            <animate attributeName="opacity" values="0.3;1;0.3" dur={`${1.5 + i * 0.3}s`} repeatCount="indefinite" />
          </circle>
        ))}
        <text x="20" y="75" textAnchor="middle" fontSize="9" fill={C.text2} fontWeight="600">
          {sleep ? `${sleep}h sueño` : "Sueño"}
        </text>
      </g>
      {/* Tobacco */}
      <g transform="translate(80,20)">
        {tobacco === "No" ? (
          <>
            <circle cx="20" cy="40" r="18" fill={C.okL} />
            <path d="M12 40 L18 47 L30 33" stroke={C.ok} strokeWidth="3" fill="none" strokeLinecap="round" />
          </>
        ) : tobacco === "Si" ? (
          <>
            <circle cx="20" cy="40" r="18" fill={C.errL} />
            <line x1="13" y1="33" x2="27" y2="47" stroke={C.err} strokeWidth="2.5" strokeLinecap="round" />
            <line x1="27" y1="33" x2="13" y2="47" stroke={C.err} strokeWidth="2.5" strokeLinecap="round" />
            <circle cx="20" cy="20" r="3" fill={C.text2} opacity="0.15">
              <animate attributeName="cy" values="22;12;22" dur="2s" repeatCount="indefinite" />
              <animate attributeName="opacity" values="0.2;0;0.2" dur="2s" repeatCount="indefinite" />
            </circle>
          </>
        ) : (
          <circle cx="20" cy="40" r="18" fill={C.bgAlt} />
        )}
        <text x="20" y="75" textAnchor="middle" fontSize="9" fill={C.text2} fontWeight="600">Tabaco</text>
      </g>
      {/* Alcohol */}
      <g transform="translate(140,20)">
        <circle
          cx="20" cy="40" r="18"
          fill={alcohol === "Nunca" ? C.okL : alcohol === "Frecuente (diario)" ? C.errL : alcohol ? C.warnL : C.bgAlt}
          style={{ transition: "fill 0.4s" }}
        />
        {alcohol === "Nunca" && (
          <path d="M12 40 L18 47 L30 33" stroke={C.ok} strokeWidth="3" fill="none" strokeLinecap="round" />
        )}
        {alcohol === "Frecuente (diario)" && (
          <text x="20" y="44" textAnchor="middle" fontSize="14" fill={C.err}>!</text>
        )}
        {alcohol === "Ocasional" && (
          <text x="20" y="44" textAnchor="middle" fontSize="11" fill={C.warn}>~</text>
        )}
        <text x="20" y="75" textAnchor="middle" fontSize="9" fill={C.text2} fontWeight="600">Alcohol</text>
      </g>
    </svg>
  );
}

export function MedsSVG({ useMeds }) {
  return (
    <svg viewBox="0 0 160 120" style={{ width: "100%", maxWidth: 160, display: "block", margin: "0 auto" }}>
      <circle cx="80" cy="55" r="40" fill={C.priL} opacity="0.5" />
      <rect x="58" y="35" width="44" height="20" rx="10" fill={useMeds === "Si" ? C.pri : C.textOff} style={{ transition: "fill 0.4s" }} />
      <rect x="58" y="50" width="44" height="20" rx="10" fill={useMeds === "Si" ? C.sec : C.textOff} opacity="0.7" style={{ transition: "fill 0.4s" }} />
      <circle cx="80" cy="45" r="3" fill="white" opacity="0.8" />
      <circle cx="80" cy="60" r="3" fill="white" opacity="0.8" />
      <text x="80" y="105" textAnchor="middle" fontSize="10" fill={C.text2} fontWeight="600">Medicamentos</text>
    </svg>
  );
}

export function ConsentSVG({ accepted }) {
  return (
    <svg viewBox="0 0 160 140" style={{ width: "100%", maxWidth: 180, display: "block", margin: "0 auto" }}>
      <defs>
        <linearGradient id="gc" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={C.pri} />
          <stop offset="100%" stopColor={C.ok} />
        </linearGradient>
      </defs>
      <circle cx="80" cy="60" r={accepted ? 48 : 42} fill="url(#gc)" opacity={accepted ? 0.12 : 0.06} style={{ transition: "all 0.6s ease" }} />
      <rect x="55" y="25" width="50" height="65" rx="6" fill="white" stroke={accepted ? C.ok : C.border} strokeWidth="2" style={{ transition: "stroke 0.4s" }} />
      <line x1="65" y1="40" x2="95" y2="40" stroke={C.border} strokeWidth="2" />
      <line x1="65" y1="50" x2="90" y2="50" stroke={C.border} strokeWidth="2" />
      <line x1="65" y1="60" x2="85" y2="60" stroke={C.border} strokeWidth="2" />
      <line x1="65" y1="70" x2="88" y2="70" stroke={C.border} strokeWidth="2" />
      {accepted ? (
        <g>
          <circle cx="95" cy="80" r="14" fill={C.ok} />
          <path d="M89 80 L93 85 L102 74" stroke="white" strokeWidth="3" fill="none" strokeLinecap="round" />
          <circle cx="115" cy="50" r="3" fill={C.acc}>
            <animate attributeName="opacity" values="0;1;0" dur="1.5s" repeatCount="indefinite" />
          </circle>
          <circle cx="40" cy="45" r="2" fill={C.sec}>
            <animate attributeName="opacity" values="0.5;1;0.5" dur="1.8s" repeatCount="indefinite" />
          </circle>
        </g>
      ) : (
        <g opacity="0.4">
          <line x1="90" y1="82" x2="105" y2="67" stroke={C.text2} strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="106" cy="66" r="2" fill={C.text2} />
        </g>
      )}
      <text x="80" y="125" textAnchor="middle" fontSize="10" fill={accepted ? C.ok : C.text2} fontWeight="600">
        {accepted ? "¡Estás listo/a!" : "Firma tu consentimiento"}
      </text>
    </svg>
  );
}
